// api/aws/users/useUpdateUser.ts
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'

type UpdateUserVars = {
  user_uuid: string
  patch: Record<string, any> // or tighten this to your User type
}

export const useUpdateUser = () => {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async ({ user_uuid, patch }: UpdateUserVars) => {
      const { data } = await axios.put(`${baseUrl}/aws/update/users/${user_uuid}`, patch)
      return data // updated user item
    },
    onSuccess: (updated, { user_uuid }) => {
      // Update user detail cache (if you have it)
      qc.setQueryData(['user', user_uuid], (prev: any) => ({ ...(prev ?? {}), ...(updated ?? {}) }))

      // Update users list cache (if you cache it)
      qc.setQueryData(['users'], (prev: any[] | undefined) =>
        Array.isArray(prev) ? prev.map(u => (u.user_uuid === user_uuid ? { ...u, ...updated } : u)) : prev
      )
    },
  })
}
